import { render, staticRenderFns } from "./PaidOverdue.vue?vue&type=template&id=1ff98829&scoped=true"
import script from "./PaidOverdue.vue?vue&type=script&lang=js"
export * from "./PaidOverdue.vue?vue&type=script&lang=js"
import style0 from "./PaidOverdue.vue?vue&type=style&index=0&id=1ff98829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff98829",
  null
  
)

export default component.exports